import { AuthenticatedLayout } from "../../../../layouts";
import { FC } from "react";
import { RQDueRemittanceTransacitons } from "../../../../components/DirectDeposit/Transactions/RQDueRemittance";

export interface IRQDueRemittanceTransacitonsPage { }

export const RQDueRemittanceTransacitonsPage: FC<IRQDueRemittanceTransacitonsPage> = () => {
	return (
		<AuthenticatedLayout
			pageTitle="RQ Due"
			breadcrumbCurrentPageName=""
			breadcrumbLinks={[]}
			mainContents={<RQDueRemittanceTransacitons />}
		/>
	);
};
